
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { backHomes } from '@/utils/h5ToApp'
import { Action } from 'vuex-class'
@Component
export default class SearchNav extends Vue {
  @Prop({ default: '' }) placeholder!: string
  @Prop({ default: '' }) defaultValue!: string
  @Prop({ default: '50' }) maxlength!: string
  @Prop({ default: false }) isFocus!: boolean
  @Prop({default: '#333'}) color?: string // 字体图标颜色
  @Prop({default: true}) showBackHome!: boolean
  @Prop({ default: () => { } }) readonly handleBack?: () => void // 返回
  @Prop({ default: () => {} }) readonly handleHomeBack?: () => void // 返回首页
  @Action setOrderFromPage!:(val: string) => void

  value = this.defaultValue
  @Watch('defaultValue')
  onDefaultValueChange (val: string) {
    this.value = val
  }

  created () {
    if (this.isFocus) {
      this.$nextTick(() => {
        (this.$refs.search as any).getElementsByTagName('input')[0].focus()
      })
    }
  }

  onSearch () {
    this.$emit('searchFunc', this.value)
  }

  goBack () {
    if (this.handleBack) {
      this.handleBack()
    } else {
      this.$router.back()
    }
  }
  /**
   * 直接跳转回首页
   */
  goHome(){
    if(this.$store.state.order.orderFromPage==='1'){
      this.setOrderFromPage('0')
      backHomes()
      return false
    }
    if (this.handleHomeBack) {
      this.handleHomeBack()
    } else {
      this.$goHomeBack()
    }
  }

}
